import useAuth from '../../component/useAuth';
import Template from '../../component/Template';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';


import logo from "../../Assets/images/gif/danger.gif";


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { useDownloadExcel } from 'react-export-table-to-excel';

export default function Faculty() {
  const navigate = useNavigate();
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/collge/");
  }


  const [college, setCollegeData] = useState([]);
  const [isDelete, setDelete] = useState(false);
  const [deleteid, setDeleteid] = useState(false);
  const [istost, settost] = useState(false);
  const tableRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [isAccess, setAccess] = useState({
    addCollege: false,
    viewCollege: false,
    updateCollege: false,
    deleteCollege: false
  });
  //20/3/2024
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year}, ${hour}:${minute}`;
  }

  const [showModal, setShowModal] = useState(false); // State to control modal visibility 20/3/2024
  const [selectedcollege_address, setSelectedcollege_address] = useState(null); // State to store selected faculty
  const [selectedCollegename, setSelectedCollegeName] = useState(null);
  const [selectedCollegeType, setSelectedCollegeType] = useState(null);
  const [selectedCollegeEmail, setSelectedCollegeEmail] = useState(null);
  const [selectedCollegeContactNo, setSelectedCollegeContactNo] = useState(null);
  const [selectedCollegeContactNo2, setSelectedCollegeContactNo2] = useState(null);
  const [selectedcollege_web, setSelectedcollege_web] = useState(null);
  const [selectedcollege_pincode, setSelectedcollege_pincode] = useState(null);

  //21/3/2024
  const [totalcollege, setTotalCollege] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);


  // Function to handle sorting-sort05/03/2024
  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };

  // Function to filter faculty data based on search query and sortBy state
  useEffect(() => {
    const filteredAndSortedData = [...college].filter(college => {
      return (
        college.college_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        college.college_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        college.college_email.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }).sort((a, b) => {
      if (sortBy.direction === 'asc') {
        return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
      } else {
        return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
      }
    });
    setfilteredAndSortedData(filteredAndSortedData);
  }, [searchQuery, sortBy, college]);






  // Sort userlog based on sortBy state-sort05/03/2024
  /*const facultydata = [...faculty].sort((a, b) => {
    if (sortBy.direction === 'asc') {
      return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
    } else {
      return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
    }
  });*/
  // Function to render sort icon-sort05/03/2024
  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'College Database',
    sheet: 'College',
  });

  useEffect(() => {
    const access = async () => {
      const { http } = Api();
      const id = localStorage.getItem("id");
      try {
        const response = await http.get('/Admin/get-all-user-permissions', { params: { user_id: id } });
        const permissions = response.data.map(permission => permission.name);

        const hasAddCollegePermission = permissions.includes("add-college");
        const hasViewCollegePermission = permissions.includes("view-college");
        const hasUpdateCollegePermission = permissions.includes("update-college");
        const hasDeleteCollegePermission = permissions.includes("delete-college");

        setAccess({
          addCollege: hasAddCollegePermission,
          viewCollege: hasViewCollegePermission,
          updateCollege: hasUpdateCollegePermission,
          deleteCollege: hasDeleteCollegePermission
        });
      } catch (error) {
        console.error("Error fetching user roles:", error);
      }
    };
    access();
  }, []);


  useEffect(() => {
    settost(sessionStorage.getItem("message"));
    fetchData();

  }, [currentPage]);

  const fetchData = async () => {
    try {

      const { http } = Api();
      const response = await http.get(`/Admin/getcollege?page=${currentPage}`, {
        params: {
          limit: '50',
        }
      });
      console.log(response);
      setCollegeData(response.data.data);
      setTotalPages(Math.ceil(response.data.total / 50));
      setTotalCollege(response.data.total);
    } catch (error) {
      console.error('Error fetching College data:', error);
    }
  };



  useEffect(() => {
    if (istost) {
      toast.success(istost);
      sessionStorage.removeItem("message");
      settost(false);
    }
  }, [istost]);

  const handleDeleteSuccess = async () => {
    const { http } = Api();
    try {
      const response = await http.delete(`/Admin/deletecollege/${deleteid}`);
      console.log(response);
      if (response.data.status_code === "MSG3") {
        setDelete(false);
        sessionStorage.setItem("message", "College  deleted successfully!")
        window.location.reload();
      }
    } catch (error) {
      toast.error("Something went wrong"); // Show error toast
      console.error('Error deleting College:', error);
    }
  }

  const encodeID = id => {
    return btoa(id);
  };

  const handleDelete = (id) => {
    setDeleteid(id);
    setDelete(true);
  }

  const handleCancel = () => {
    setDelete(false);
  }

  const handleExportDropdownToggle = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "1") {
      // Handle PDF conversion
    } else if (selectedValue === "2") {
      // Handle CSV conversion
    } else if (selectedValue === "3") {
      onDownload();
    }
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  //20/3/2024
  // Function to open modal and set selected faculty
  const handleViewModalOpen = (college_address, college_pincode, college_contact_no, college_web, college_name, college_contact_no2, college_email, college_type) => {

    setSelectedCollegeName(college_name);
    setSelectedCollegeType(college_type);
    setSelectedCollegeEmail(college_email);
    setSelectedCollegeContactNo(college_contact_no);
    setSelectedcollege_pincode(college_pincode);
    setSelectedCollegeContactNo2(college_contact_no2);
    setSelectedcollege_address(college_address);
    setSelectedcollege_web(college_web);



    setShowModal(true);
  };

  // Function to close modal
  const handleModalClose = () => {
    setShowModal(false);
  };
  // Function to handle changes in the search input field
  const handleSearchInputChange = (event) => {
    //console.log(event.target.value+"onchange");
    setSearchQuery(event.target.value);
  };

  const [ismobile, setIsmobile] = useState(false);
  const togglemenu = () => {
      setIsmobile(!ismobile);
  };





  return (
    <>
      <ToastContainer />
      <Template>



        <div className={`modal fade show ${showModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className="modal-toggle-wrapper">


                  <div class="d-flex mt-3">

                    <div class="flex-grow-1 ms-2">
                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> College Name: {selectedCollegename}</p>
                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> College Type: {selectedCollegeType}</p>
                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> College Email: {selectedCollegeEmail}</p>
                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> College Contact No: {selectedCollegeContactNo}</p>
                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> College Contact No: {selectedCollegeContactNo2}</p>
                      <p>
                        <i class="fa fa-thumb-tack" aria-hidden="true"></i> College Website:
                        <a href={"https://" + selectedcollege_web} target="_blank">{selectedcollege_web}</a>
                      </p>

                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> College Address: {selectedcollege_address}</p>
                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> College Pincode: {selectedcollege_pincode}</p>
                    </div>

                  </div>

                  <center>
                    <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleModalClose()}>Cancel</button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>






        <div className={`modal fade show ${isDelete ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className="modal-toggle-wrapper">
                  <ul className="modal-img">
                    <li> <img src={logo} /></li>
                  </ul>
                  <h4 className="text-center pb-2">Are you sure you want to delete?</h4>
                  <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p>
                  <div className="d-flex justify-content-center mt-3">
                    <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Delete</button>
                    <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleCancel()}>Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="card">
              <div className="card-header card-heading">
                  <div className="py-3 d-flex justify-content-between align-items-center">
                    <h5 className="lbl1">College</h5>
                    <div className="d-flex ml-auto">
                      {/* Responsive Dropdown or Hamburger Menu */}
                      <div className="dropdown d-lg-none">
                        <button
                          className="btn btn-light dropdown-toggle"
                          type="button"
                          id="mobileActionsDropdown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded={ismobile}
                          onClick={togglemenu}
                        >
                          <i className="fas fa-bars"></i>
                        </button>
                        <div
                          className={`dropdown-menu dropdown-menu-right ${ismobile ? 'show' : ''}`}
                          aria-labelledby="mobileActionsDropdown"
                          style={{
                            margin: '10px 20px 20px -60px',
                            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                            borderRadius: '0.5rem',
                            overflow: 'hidden',
                            color: 'black',
                          }}
                        >
                  
                          <div className="dropdown-item py-3">
                            <select
                              className="form-select btn-border"
                              id="inputGroupSelect01"
                              onChange={handleExportDropdownToggle}
                              style={{ cursor: "pointer" }}
                            >
                              <option selected="">Export As</option>
                              <option value="1">Pdf</option>
                              <option value="2">Csv</option>
                              <option value="3">Excel</option>
                            </select>
                          </div>
                          <div className="dropdown-divider my-0"></div>
                          {isAccess.addCollege && (
                            <Link className="dropdown-item" to="/admin/CollegeAdd">
                              <i
                                className="bi bi-plus-circle-fill show"
                                style={{ cursor: "pointer", color: 'black' }}
                              > Add New</i>
                            </Link>
                          )}
                        </div>
                      </div>


                      {/* Desktop View */}
                      <div className="d-none d-lg-flex">
                        <div className="form-group">
                          <select className="form-select btn-border" id="inputGroupSelect01" onChange={handleExportDropdownToggle} style={{ cursor: "pointer" }}>
                            <option selected="">Export As</option>
                            <option value="1">Pdf</option>
                            <option value="2">Csv</option>
                            <option value="3">Excel</option>
                          </select>
                        </div>
                        &nbsp;&nbsp;
                        {isAccess.addCollege && (
                          <Link className="btn btn-primary form-group" to="/admin/CollegeAdd">
                            <span className="icon">&#43;</span>
                            <div className="txtsh"> Add New</div>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {isAccess.viewCollege ? (
                  <div className="card-body">
                    <div className="card-body pdg1">
                      <div className="table-responsive ovrflw">
                        <div className='row'>
                        <div className='col-md-6 wdt' >
                            <p>
                              Showing {(currentPage - 1) * 50 + 1}{''}-
                              {Math.min((currentPage - 1) * 50 + 50, totalcollege)} of {totalcollege} entries
                            </p>
                          </div>
                          <div className='col-md-6 wdt' align='right'>
                            <input
                              type="text"
                              value={searchQuery}
                              onChange={handleSearchInputChange}
                              placeholder="Search..."
                              className='form-control'

                            /></div></div>
                        <table className="display dataTable table-striped table-bordered" ref={tableRef}>
                          <thead>
                            <tr className="bg-primary">
                              <th onClick={() => handleSort('created_at')}>Sl No &nbsp;
                                {renderSortIcon('created_at')} </th>
                              <th style={{ width: '20%' }} onClick={() => handleSort('college_name')}>College Name &nbsp;
                                {renderSortIcon('college_name')}</th>
                              <th width="20%" onClick={() => handleSort('college_type')}>College Type &nbsp;
                                {renderSortIcon('college_type')}</th>

                              <th onClick={() => handleSort('college_contact_no')}>Contact No. &nbsp;
                                {renderSortIcon('college_contact_no')}</th>

                              {(isAccess.deleteCollege || isAccess.updateCollege || isAccess.viewcollege) && (
                                <th>Action</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>

                            {filteredAndSortedData.map((college, index) => {
                              if (college.status !== 'deleted') {
                               
                               

                               
                                const serialNumber = (currentPage - 1) * 50 + index + 1;
                                

                                return (
                                  <tr key={college.college_name}>
                                    <td>{serialNumber}</td>
                                    <td style={{ width: '20%' }}>{college.college_name}</td>
                                    <td>{college.college_type}</td>
                                    <td>{college.college_contact_no}</td>
                                    <td>
                                      <ul className="action">
                                        {isAccess.updateCollege && (
                                          <li className="edit">
                                            <Link to={`/admin/collegeedit/${encodeID(college.id)}`}>
                                              <i className="icon-pencil-alt"></i>
                                            </Link>
                                          </li>
                                        )}
                                        {isAccess.deleteCollege && (
                                          <li className="delete">
                                            <div style={{ cursor: "pointer" }} onClick={() => handleDelete(college.id)}>
                                              <i className="icon-trash"></i>
                                            </div>
                                          </li>
                                        )}&nbsp;
                                        {isAccess.viewCollege && (
                                          <li className="view">
                                            <span className="icon-eye" style={{ cursor: "pointer" }} onClick={() => handleViewModalOpen(college.college_address, college.college_pincode, college.college_contact_no, college.college_web, college.college_name, college.college_contact_no2, college.college_email1, college.college_type)}>
                                            </span>
                                          </li>
                                        )}
                                      </ul>
                                    </td>
                                  </tr>
                                );
                              } else {
                                return null; // Skip rendering for deleted data
                              }
                            })}

                          </tbody>
                        </table>
                      </div>
                      {totalPages > 1 && (
                                  <nav aria-label="..." style={{ cursor: "pointer" }}>
                                  <ul className="pagination justify-content-center">
                                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                          <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                      </li>
                                      <li className={`page-item`}>
                                          <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                      </li>
                                      {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                      {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                          <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                              <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                          </li>
                                      ))}
                                      {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                      <li className={`page-item`}>
                                          <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                      </li>

                                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                          <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                      </li>
                                  </ul>
                              </nav>
                      )}

                    </div>
                  </div>
                ) : (
                  <div className="card-body">
                    <div className="card-body pdg1">
                      <div className="table-responsive">
                        YOU DONT HAVE ACCESS TO VIEW THIS
                      </div>
                    </div>
                  </div>

                )}
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
